import { Modals } from '@/core'
import { HostingModel, ServerModel } from '@/models'
import { URL_ADD_PRODUCT } from '@/utils'
import { ProductViewModel } from '@/view-models'
import { CartModalManager } from './cart-modal.manager'
import { CommonProductButtonView } from './common-product-button.view'

export class ProductButtonView extends CommonProductButtonView {
  private model: HostingModel | ServerModel
  private productViewModel: ProductViewModel
  private submitButton: HTMLButtonElement
  constructor(
    model: HostingModel | ServerModel,
    widget: HTMLElement,
    modalManager: CartModalManager,
    productViewModel: ProductViewModel
  ) {
    super(widget, modalManager)

    this.model = model
    this.productViewModel = productViewModel

    const button =
      this.widget.querySelector<HTMLButtonElement>('.js-pricing-action') ??
      this.widget.querySelector<HTMLButtonElement>('.js-add-product')

    if (!button) {
      throw new Error('ProductButton: button missing')
    }

    this.submitButton = button

    this.submitButton.addEventListener('click', (event) => {
      event.preventDefault()
      this.onClick()
    })
  }
  async onClick(): Promise<void> {
    let modelCopy = this.model.clone()

    // Fix: Redirect To WHMCS Addd Domain when product requires domain
    if (modelCopy.requiresDomain) {
      location.replace(`${URL_ADD_PRODUCT}&pid=${modelCopy.id}`)
      return
    }

    if (modelCopy.requiresDomain) {
      this.modalManager.open(Modals.DOMAIN)
      modelCopy = await this.modalManager.onSubmit(Modals.DOMAIN, modelCopy)
    }

    if (modelCopy.isServer) {
      this.modalManager.open(Modals.SERVER)
      modelCopy = await this.modalManager.onSubmit(Modals.SERVER, modelCopy)
    }

    if (modelCopy.hasCustomFields) {
      this.modalManager.open(Modals.CUSTOM_FIELDS)
      modelCopy = await this.modalManager.onSubmit(
        Modals.CUSTOM_FIELDS,
        modelCopy
      )
    }

    this.submitButton.classList.add('button--is-loading')

    this.modalManager.open(Modals.PRICING)
    await this.productViewModel.addToCart(modelCopy)

    this.submitButton.classList.remove('button--is-loading')
  }
}
